import { api } from '@/shared/api';
import type { UpdateApplicationMemoRequest, UpdateApplicationMemoResponse } from '../model/types';

/**
 * 管理メモ更新API
 *
 * 申込情報の一括更新とは独立して、管理メモのみを更新する。
 *
 * @param applicationId 申込ID
 * @param body 更新リクエストボディ（memo）
 * @returns 更新された申込ID
 */
export const updateApplicationMemo = async (
    applicationId: string,
    body: UpdateApplicationMemoRequest
): Promise<UpdateApplicationMemoResponse> => {
    return api.patch('/applications/{application_id}/memo', {
        path: { application_id: applicationId },
        body,
    });
};
